import { Ref } from 'react';
import clsx from 'clsx';
import { IWithClassname } from '@/models/common';
import s from './HtmlViewer.module.scss';

interface Props extends IWithClassname {
  label?: string;
  text?: string | null;
  isContentBlock?: boolean;
  ref?: Ref<HTMLDivElement> | null;
}

export const HtmlViewer = ({ label, text, className, isContentBlock, ref }: Props) => {
  if (!text) return null;

  return (
    <div ref={ref} className={clsx(s.viewer, className)}>
      {label && <span className={s.viewer__label}>{label}:&nbsp;</span>}
      <div
        dangerouslySetInnerHTML={{ __html: text }}
        className={clsx(s.viewer__content, { [s.viewer__content_block]: isContentBlock })}
      />
    </div>
  );
};